var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPractical(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2,0,0,2,0,0)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M3.5,23.5,1.49,21a4.5,4.5,0,0,1-1-2.81V13A1.5,1.5,0,0,1,2,11.5H2A1.5,1.5,0,0,1,3.5,13v3.87",
    style: {
      fill: "none",
      stroke: "inherit",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8,23.5V20.36a4.43,4.43,0,0,0-.76-2.49L6.1,16.15a1.41,1.41,0,0,0-2-.44h0a1.4,1.4,0,0,0-.47,1.79L5,19.75",
    style: {
      fill: "none",
      stroke: "inherit",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5,23.5l2-2.52a4.5,4.5,0,0,0,1-2.81V13A1.5,1.5,0,0,0,22,11.5h0A1.5,1.5,0,0,0,20.5,13v3.87",
    style: {
      fill: "none",
      stroke: "inherit",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16,23.5V20.36a4.43,4.43,0,0,1,.76-2.49l1.14-1.72a1.41,1.41,0,0,1,2-.44h0a1.4,1.4,0,0,1,.47,1.79L19,19.75",
    style: {
      fill: "none",
      stroke: "inherit",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M13.55,11.4a2,2,0,1,1,2.83-2.83,2.12,2.12,0,0,1,.45.68.47.47,0,0,0,.36.31.51.51,0,0,0,.46-.13l1.56-1.57a1,1,0,0,0,0-1.41L17.6,4.85A2,2,0,1,0,15.15,2.4L13.55.79a1,1,0,0,0-1.41,0L10.69,2.24a.53.53,0,0,0-.15.41.51.51,0,0,0,.22.36,2.6,2.6,0,0,1,.32.26A2,2,0,0,1,8.25,6.1,2.6,2.6,0,0,1,8,5.78a.49.49,0,0,0-.77-.07L5.77,7.16a1,1,0,0,0,0,1.41l5.66,5.66a1,1,0,0,0,1.41,0l1.56-1.56a.5.5,0,0,0-.17-.82A2,2,0,0,1,13.55,11.4Z",
    style: {
      fill: "none",
      stroke: "inherit",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPractical);
export default __webpack_public_path__ + "static/media/practical.14c44480.svg";
export { ForwardRef as ReactComponent };